export default __webpack_public_path__ + "static/media/image1.55aaa5b1.png";